import './logo.scss'
import type { FC } from 'react'
import { NavLink } from 'react-router-dom-v7'
import { cmsDataService } from '@/content/services/cms.data.service'
import { navigationService } from '@/content/services/navigation.service'
import type { B2BHeaderAndFooterPropsApi } from '@/features/b2b/b2bHeaderAndFooter.models'

interface LogoProps {
    isB2B?: boolean
    b2bHeaderAndFooterData?: B2BHeaderAndFooterPropsApi
}

export const Logo: FC<LogoProps> = ({ isB2B = false, b2bHeaderAndFooterData }) => {
    const { logo, mobileLogo, b2bLogo } = cmsDataService.get()

    const homePage = navigationService.getPageUrl('Home')
    const b2bHomePage = b2bHeaderAndFooterData?.b2BPage.url
    const b2bDesktopLogo = b2bHeaderAndFooterData?.logo.desktop

    const desktopLogoUrl = isB2B ? b2bDesktopLogo : logo?.url
    const mobileLogoUrl = isB2B ? b2bDesktopLogo : (mobileLogo?.url ?? logo?.url)

    const logoAlt = isB2B && b2bLogo?.url ? b2bLogo.alt : logo?.alt
    const destination = isB2B ? b2bHomePage : homePage

    if (!desktopLogoUrl || !mobileLogoUrl || !destination) {
        return null
    }

    return (
        <div className="logo">
            <NavLink to={destination} aria-label={logoAlt || 'Home'}>
                <picture className="logo-picture">
                    <source media="(max-width: 1024px)" srcSet={mobileLogoUrl} />
                    <img src={desktopLogoUrl} className="logo-image" alt={logoAlt || ''} />
                </picture>
            </NavLink>
        </div>
    )
}
